import { Component } from '@angular/core';
@Component({
  selector: 'app-register-carrier-final-step',
  templateUrl: './register-carrier-final-step.component.html',
  styleUrls: ['./register-carrier-final-step.component.scss'],
})
export class RegisterCarrierFinalStepComponent {
}
